<template>
    <div 
        class="rating"
        :class="scoreRating"
    >
        {{ actualScore.toFixed(2) }}
    </div>
</template>

<script>
export default {
  name: 'RatedScore',
  props: {
    actualScore: {
      type: Number
    },
    targetScore: {
      type: Number
    }   
  },
  computed: {
    scoreRating: function() {
      const diff = this.actualScore - this.targetScore;
      const ratingBoundaries = [
        {boundary: 0, rating: 'bad'},
        {boundary: 0.5, rating: 'low'},
        {boundary: 1, rating: 'lowmod'},
        {boundary: 1.5, rating: 'moderate'},
        {boundary: 2, rating: 'modhigh'},
        {boundary: 2.5, rating: 'high'},
      ]
      for (const ratingBoundary of ratingBoundaries) {
        if (diff < ratingBoundary.boundary) {
          return ratingBoundary.rating;
        }
      }
      return 'vhigh';
    }
  }
}
</script>

<style scoped>
    .bad { color: #D97874; }
    .low { color: #B6C145; }
    .lowmod { color: #88C34F; }
    .moderate { color: #77C552 ; }
    .modhigh { color: #57D65E ; }
    .high { color: #14CD68 ; }
    .vhigh { color: #00DC71 ; }
</style>
